// @flow
import React from "react";
// import Spinner from 'react-bootstrap/Spinner';
import Card from '../Card/Card';

type Props = {
  className?: string,
  children: any,
  isLoading?: boolean,
};

export default function CardWrapperForModal({
  className = '',
  children,
}: //   isLoading,
Props): React$Element<any> {
  return (
    <Card className={`for-modal ${className}`}>
      {children}

      {/* removed modal-level spinner to avoid duplicate/global overlay conflicts */}
    </Card>
  );
}
